import fetchJsonp from 'fetch-jsonp'

const outFunctions = {fetchJsonp}

export default outFunctions



// WEBPACK FOOTER //
// ./src/cnConst/outFunctions.js